import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {Product, TicketConfiguration} from '../../../../Models';

@Component
export default class TicketPrice extends Vue {
  @Prop({type: TicketConfiguration, required: true}) ticketConfiguration: TicketConfiguration | undefined;
  @Prop({type: Object, required: true}) onSiteProducts: { sb: Product | null, helpdesk: Product | null } | undefined;
}
